import { useCallback, useState } from "react";
import { LayoutDashboard, ZoomIn } from "lucide-react";
import { ImageLightbox } from "@/components/aziende/ImageLightbox";

const SRC = "/dashboard-aziende.png";
const ALT = "Dashboard Prodigy per le aziende";

const Empty = () => (
  <div className="absolute inset-0 flex flex-col items-center justify-center gap-3" data-testid="dashboard-placeholder-fallback">
    <LayoutDashboard className="h-6 w-6 text-[#3a3d44]" strokeWidth={1.5} />
    <span className="text-xs tracking-[0.25em] uppercase text-[#5b6068]">Anteprima Dashboard</span>
  </div>
);

const Shot = ({ onOpen, onError }) => (
  <button type="button" onClick={onOpen} className="zoomable group absolute inset-0 cursor-zoom-in" aria-label="Clicca per ingrandire la dashboard" data-testid="dashboard-zoom-trigger">
    <img src={SRC} alt={ALT} className="dashboard-shot absolute inset-0 h-full w-full object-contain" loading="lazy" decoding="async" data-testid="dashboard-placeholder" onError={onError} />
    <span className="zoom-hint glass absolute bottom-3 right-3 flex items-center gap-2 rounded-full px-3 py-1.5 text-[11px] tracking-[0.15em] uppercase text-white" data-testid="dashboard-zoom-hint">
      <ZoomIn className="h-3.5 w-3.5 text-cyan" /> Clicca per ingrandire
    </span>
  </button>
);

export const DashboardShot = () => {
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(false);
  const close = useCallback(() => setOpen(false), []);
  return (
    <div className="dashboard-frame glass rounded-2xl overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.5)]" data-testid="dashboard-frame">
      <div className="flex items-center gap-2 px-4 h-9 border-b border-[#1e2024]">
        {[0, 1, 2].map((i) => (
          <span key={i} className="h-2.5 w-2.5 rounded-full bg-[#2a2d33]" />
        ))}
        <span className="ml-4 h-5 flex-1 max-w-[220px] rounded-md bg-white/[0.03] border border-[#1e2024] text-[10px] text-[#5b6068] flex items-center px-3">
          app.prodigy/dashboard
        </span>
      </div>
      <div className="relative aspect-[1882/768] bg-black/20">
        {failed ? <Empty /> : <Shot onOpen={() => setOpen(true)} onError={() => setFailed(true)} />}
      </div>
      {open && <ImageLightbox src={SRC} alt={ALT} onClose={close} />}
    </div>
  );
};
